import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const NatureGroupContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];
        const valuesExtended = [];
        const labelsExtended = [];

        const sorted = data.groupNaturesWithMoreAttendances?.slice(0, 20).sort((a, b) => b.qty - a.qty);

        sorted.forEach((item) => {
            labels.push(ReportUtils.formatText(item.nature_group));
            values.push(item.qty);
        });

        data.groupNaturesWithMoreAttendances?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            labelsExtended.push(ReportUtils.formatText(item.nature_group));
            valuesExtended.push(item.qty);
        });

        GraphicUtils.barChart('nature-total-type', values, labels, false);
        ReportUtils.createExportableTable(labelsExtended, valuesExtended, "Grupo de natureza")
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <div className="chart-title mb-3">Atendimentos por grupo de natureza {data.groupNaturesWithMoreAttendances?.length > 20 ? ' (TOP 20)' : ''}</div>
                <div className="chart-report bar-chart" id="nature-total-type"></div>
            </div>
        </>
    );
};

export default NatureGroupContent;